import type { GasProperties } from "../../fluidProperties/d";

export const gasProperties: GasProperties[] = [
  {
    key: "c1MethanePercent",
    name: "Methane - C1",
    molarMass: 16.043,
    criticalTemp: 343,
    criticalPressure: 666.4,
    acentricFactor: 0.011,
    antoineA: 3.9895,
    antoineB: 443.028,
    antoineC: -0.49,
    liquidStockTankDensity: 26.4,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "c2EthanePercent",
    name: "Ethane - C2",
    molarMass: 30.07,
    criticalTemp: 549.59,
    criticalPressure: 706.5,
    acentricFactor: 0.099,
    antoineA: 3.93835,
    antoineB: 659.739,
    antoineC: -16.719,
    liquidStockTankDensity: 34.4,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "c3PropanePercent",
    name: "Propane - C3",
    molarMass: 44.097,
    criticalTemp: 665.73,
    criticalPressure: 616,
    acentricFactor: 0.152,
    antoineA: 3.98292,
    antoineB: 819.296,
    antoineC: -24.417,
    liquidStockTankDensity: 31.7,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "ic4IsobutenePercent",
    name: "Isobutene - C4",
    molarMass: 58.124,
    criticalTemp: 734.98,
    criticalPressure: 529.1,
    acentricFactor: 0.1835,
    antoineA: 4.3281,
    antoineB: 1132.108,
    antoineC: 0.918,
    liquidStockTankDensity: 35.4,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "nc4ButanePercent",
    name: "Butane - C4",
    molarMass: 58.124,
    criticalTemp: 765.29,
    criticalPressure: 550.7,
    acentricFactor: 0.1995,
    antoineA: 4.35576,
    antoineB: 1175.581,
    antoineC: -2.071,
    liquidStockTankDensity: 37.3,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "ic5IsopentanePercent",
    name: "Isopentane - C5",
    molarMass: 72.151,
    criticalTemp: 829.1,
    criticalPressure: 490.4,
    acentricFactor: 0.2275,
    antoineA: 3.97183,
    antoineB: 1059.13,
    antoineC: -34.908,
    liquidStockTankDensity: 38.6,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "nc5BentanePercent",
    name: "Bentane - C5",
    molarMass: 72.151,
    criticalTemp: 845.27,
    criticalPressure: 488.6,
    acentricFactor: 0.2515,
    antoineA: 3.97786,
    antoineB: 1064.84,
    antoineC: -42.85,
    liquidStockTankDensity: 39.7,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "c6HexanePercent",
    name: "Hexane - C6",
    molarMass: 86.178,
    criticalTemp: 913.27,
    criticalPressure: 453.6,
    acentricFactor: 0.299,
    antoineA: 4.00266,
    antoineB: 1171.53,
    antoineC: -48.784,
    liquidStockTankDensity: 41,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "c7HeptanePercent",
    name: "Heptane - C7+",
    molarMass: 100.21,
    criticalTemp: 1139.4,
    criticalPressure: 320.3,
    acentricFactor: 0.349,
    antoineA: 4.02832,
    antoineB: 1268.636,
    antoineC: -56.199,
    liquidStockTankDensity: 42.7,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "n2NitrogenPercent",
    name: "Nitrogen - N2",
    molarMass: 28.01,
    criticalTemp: 239.26,
    criticalPressure: 507.5,
    acentricFactor: 0.0385,
    antoineA: 3.7362,
    antoineB: 264.651,
    antoineC: -6.788,
    liquidStockTankDensity: 50.4,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "cO2CarbonDioxidePercent",
    name: "Carbon Dioxide - CO2",
    molarMass: 44.01,
    criticalTemp: 547.58,
    criticalPressure: 1071,
    acentricFactor: 0.2265,
    antoineA: 6.81228,
    antoineB: 1301.679,
    antoineC: -3.494,
    liquidStockTankDensity: 48.3,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "h2SHydrogenSulfidePercent",
    name: "Hydrogen Sulfide - H2S",
    molarMass: 34.076,
    criticalTemp: 672.35,
    criticalPressure: 1306,
    acentricFactor: 0.094,
    antoineA: 3.99042,
    antoineB: 643.048,
    antoineC: -32.484,
    liquidStockTankDensity: 61,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "o2OxygenPercent",
    name: "Oxygen - O2",
    molarMass: 31.999,
    criticalTemp: 278.24,
    criticalPressure: 731,
    acentricFactor: 0.022,
    antoineA: 3.85845,
    antoineB: 340.024,
    antoineC: -4.144,
    liquidStockTankDensity: 71.2,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  },
  {
    key: "arArgonPercent",
    name: "Argon - Ar",
    molarMass: 39.95,
    criticalTemp: 271.24,
    criticalPressure: 705.8,
    acentricFactor: 0,
    antoineA: 3.29555,
    antoineB: 215.24,
    antoineC: -22.233,
    liquidStockTankDensity: 87.4,
    yTc: 0,
    yPc: 0,
    yM: 0,
    fluidRatio: 0,
    vaporPressurePsi: 0,
    columnJ: 0,
    yv: 0,
    yPv: 0,
    aboveTc: false,
    abovePc: false,
    abovePv: false,
    gasState: "Gaseous",
    yw: 0,
    m: 0,
    alpha: 0,
    a: 0,
    b: 0,
    A: 0,
    B: 0,
    Z: 0,
    zLiquid: 0,
    zGas: 0,
    volumeFactorBgBc: 0,
    gasDensityLbFt3: 0,
    condensateDensity: 0,
    dewPoint: 0,
    condensateSTp: 0,
    surfaceRateCfd: 0,
    inSituRateCfd: 0,
    condiScf: 0,
    condiRateStb: 0,
    condiRateBbld: 0,
    condiYm: 0,
    gasRateCfd: 0,
    ymGas: 0,
    yCondi: 0,
    yGas: 0,
    condensateZ: 0,
    gasZ: 0,
    yCondensateDensity: 0
  }
];

// Lookup by component key (the keys are unique), instead of searching the
// table on every calculation.
export const gasPropertiesByKey = new Map(
  gasProperties.map(gp => [gp.key, gp])
);
